import styled from 'styled-components';
import {
  blue, darkerGrey, red, teko, tekoMedium, openSans,
} from '../../../utils/theme';
import { mobile } from '../../../utils/breakpoints';

export const MediaKitWrapper = styled.div`
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: right;
  background-size: cover;
  background-repeat: no-repeat;
  .xfl-media-kit {
    &__content {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      max-width: 1200px;
      margin: 0 auto;
      padding: 100px 70px;
    }

    &__title-image {
      margin-bottom: 15px;
      margin-left: -56px;
    }

    &__subtitle {
      color: ${blue};
      ${tekoMedium} margin-bottom: 20px;
      text-align: left;
    }

    &__description {
      margin-bottom: 80px;

      p {
        color: ${darkerGrey};
        ${openSans}
        font-size: 14px;
        max-width: 60%;
        letter-spacing: 1.4px;
        line-height: 22px;
        text-align: left;
      }
    }

    &__download-wrapper {
      display: flex;
    }

    &__download {
      color: ${red};
      ${teko} margin-right: 50px;
      position: relative;

      img {
        margin-right: 10px;
        margin-bottom: -7px;
        display: inline-block;
      }
      &:after {
        content: '';
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-left: 5px solid ${red};
        margin-left: 7px;
        position: absolute;
        bottom: 3px;
      }
    }
  }

  @media (max-width: ${mobile.max}px) {
    .xfl-media-kit {
      &__title-image {
        width: 160px;
        margin-left: -24px;
        margin-bottom: 7px;
      }

      &__content {
        padding: 50px 30px;
      }

      &__subtitle {
        font-size: 24px;
        letter-spacing: 2px;
      }

      &__download-wrapper {
        flex-direction: column;
      }

      &__download {
        margin: 0 0 15px 0;
      }

      &__description {
        margin-bottom: 40px;

        p {
          max-width: 100%;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/media-kit/styles/mediaKit.style.js